/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Create_RoleInputs */

const en_admin_roles_create_role = /** @type {(inputs: Admin_Roles_Create_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Role`)
};

/**
* | output |
* | --- |
* | "Create Role" |
*
* @param {Admin_Roles_Create_RoleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_create_role = /** @type {((inputs?: Admin_Roles_Create_RoleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Create_RoleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_create_role(inputs)
});
export { admin_roles_create_role as "admin.roles.create_role" }